import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import type { TabElementProperty } from '../../types'

const initialState: TabElementProperty[] = []

export const tabElementPropertiesSlice = createSlice({
  name: 'tabElementProperties',
  initialState,
  reducers: {
    addTabElementProperties(state, action: PayloadAction<TabElementProperty[]>) {
      return action.payload
    },
  },
})

export default tabElementPropertiesSlice.reducer
